// Custom SVG icons used on the Canvas page (moved verbatim from CanvasPage).

/** Chat header: collapse the chat panel. */
export function CollapsePanelIcon() {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M0 17.9375C0 18.5263 0.477679 19 1.07143 19C1.66518 19 2.14286 18.5263 2.14286 17.9375V3.0625C2.14286 2.4737 1.66518 2 1.07143 2C0.477679 2 0 2.4737 0 3.0625V17.9375ZM6.05357 9.72526C5.83929 9.92448 5.71429 10.2078 5.71429 10.5C5.71429 10.7922 5.83482 11.0711 6.05357 11.2747L12.125 16.9414C12.558 17.3443 13.2321 17.3221 13.6384 16.8971C14.0446 16.4721 14.0223 15.7992 13.5938 15.3964L9.48661 11.5625H13.2143H18.9286C19.5223 11.5625 20 11.0888 20 10.5C20 9.9112 19.5223 9.4375 18.9286 9.4375H13.2143H9.48661L13.5893 5.60807C14.0223 5.20521 14.0402 4.53229 13.6339 4.10729C13.2277 3.68229 12.5491 3.66016 12.1205 4.06302L6.04911 9.72969L6.05357 9.72526Z"
				fill="currentColor"
			/>
		</svg>
	);
}

/** Chat composer toolbar. */
export function ChipIcon() {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3.33594 4.0026C3.33594 3.82579 3.40618 3.65622 3.5312 3.5312C3.65622 3.40618 3.82579 3.33594 4.0026 3.33594H12.0026C12.1794 3.33594 12.349 3.40618 12.474 3.5312C12.599 3.65622 12.6693 3.82579 12.6693 4.0026V12.0026C12.6693 12.1794 12.599 12.349 12.474 12.474C12.349 12.599 12.1794 12.6693 12.0026 12.6693H4.0026C3.82579 12.6693 3.65622 12.599 3.5312 12.474C3.40618 12.349 3.33594 12.1794 3.33594 12.0026V4.0026Z"
				stroke="currentColor"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6 6H10V10H6V6Z"
				stroke="currentColor"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 6.66406H3.33333"
				stroke="currentColor"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 9.33594H3.33333"
				stroke="currentColor"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.66406 2V3.33333"
				stroke="currentColor"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.33594 2V3.33333"
				stroke="currentColor"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.9974 6.66406H12.6641"
				stroke="currentColor"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.9974 9.33594H12.6641"
				stroke="currentColor"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.33594 13.9974V12.6641"
				stroke="currentColor"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.66406 13.9974V12.6641"
				stroke="currentColor"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

/** Chat composer toolbar. */
export function GlobeIcon() {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8Z"
				stroke="currentColor"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2.39844 6H13.5984"
				stroke="currentColor"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2.39844 10H13.5984"
				stroke="currentColor"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7.66384 2C6.54074 3.79974 5.94531 5.87858 5.94531 8C5.94531 10.1214 6.54074 12.2003 7.66384 14"
				stroke="currentColor"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8.33594 2C9.45904 3.79974 10.0545 5.87858 10.0545 8C10.0545 10.1214 9.45904 12.2003 8.33594 14"
				stroke="currentColor"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

/** Chat composer toolbar. */
export function PaperclipIcon() {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9.99785 4.66436L5.66452 8.9977C5.3993 9.26291 5.2503 9.62263 5.2503 9.9977C5.2503 10.3728 5.3993 10.7325 5.66452 10.9977C5.92973 11.2629 6.28944 11.4119 6.66452 11.4119C7.03959 11.4119 7.3993 11.2629 7.66452 10.9977L11.9978 6.66436C12.5283 6.13393 12.8263 5.41451 12.8263 4.66436C12.8263 3.91422 12.5283 3.1948 11.9978 2.66436C11.4674 2.13393 10.748 1.83594 9.99785 1.83594C9.2477 1.83594 8.52828 2.13393 7.99785 2.66436L3.66452 6.9977C2.86887 7.79335 2.42187 8.87248 2.42188 9.9977C2.42188 11.1229 2.86887 12.202 3.66452 12.9977C4.46017 13.7933 5.5393 14.2403 6.66452 14.2403C7.78973 14.2403 8.86887 13.7933 9.66452 12.9977L13.9978 8.66436"
				stroke="currentColor"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

/** Zoom controls: hand (pan) tool. */
export function HandToolIcon() {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_842_6741)">
				<path
					d="M19.117 3.09583C18.5578 2.62 17.817 2.415 17.0845 2.53417C16.9078 2.5625 16.7378 2.61167 16.577 2.6775C16.2878 1.61667 15.3161 0.833333 14.1653 0.833333C13.7195 0.833333 13.3011 0.950833 12.9386 1.15667C12.4936 0.4625 11.7161 0 10.832 0C9.68031 0 8.70865 0.7825 8.41948 1.84417C8.25781 1.77833 8.08865 1.72917 7.91198 1.7C7.17948 1.58167 6.43865 1.78583 5.87948 2.26167C5.31948 2.7375 4.99865 3.43167 4.99865 4.16667V11.415L4.20198 10.6708C3.19531 9.73333 1.61281 9.78667 0.673647 10.7917C-0.267186 11.7983 -0.214686 13.3833 0.78198 14.3175L3.52698 16.9642C5.55698 18.9217 8.22698 19.9992 11.0461 19.9992H12.4986C16.6336 19.9992 19.9986 16.6342 19.9986 12.4992V5.00083C19.9986 4.26667 19.677 3.5725 19.117 3.09583ZM18.3311 12.5008C18.3311 15.7175 15.7145 18.3342 12.4978 18.3342H11.0453C8.66031 18.3342 6.40031 17.4225 4.68281 15.7667L1.92948 13.1117C1.59365 12.7967 1.57615 12.2675 1.89031 11.9308C2.20365 11.5967 2.73031 11.5792 3.06448 11.8908L5.26281 13.9433C5.50615 14.17 5.86031 14.23 6.16365 14.0983C6.46781 13.9658 6.66531 13.6658 6.66531 13.3342V4.1675C6.66531 3.9225 6.77198 3.69083 6.95948 3.5325C7.14948 3.37167 7.39198 3.30583 7.64531 3.34583C8.03031 3.40917 8.33281 3.80917 8.33281 4.25667V8.33417C8.33281 8.79417 8.70615 9.1675 9.16615 9.1675C9.62615 9.1675 9.99948 8.79417 9.99948 8.33417V2.50083C9.99948 2.04167 10.3736 1.6675 10.8328 1.6675C11.292 1.6675 11.6661 2.04167 11.6661 2.50083V8.33417C11.6661 8.79417 12.0395 9.1675 12.4995 9.1675C12.9595 9.1675 13.3328 8.79417 13.3328 8.33417V3.33417C13.3328 2.875 13.707 2.50083 14.1661 2.50083C14.6253 2.50083 14.9995 2.875 14.9995 3.33417V8.33417C14.9995 8.79417 15.3728 9.1675 15.8328 9.1675C16.2928 9.1675 16.6661 8.79417 16.6661 8.33417V5.09C16.6661 4.64167 16.9678 4.24167 17.3536 4.17917C17.6061 4.14 17.8495 4.20417 18.0395 4.36583C18.2261 4.52417 18.3336 4.75583 18.3336 5.00083V12.5008H18.3311Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_842_6741">
					<rect width="20" height="20" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

/** Zoom controls: move (pointer) tool. */
export function PointerToolIcon() {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4 0L4 20L8.8 15.2L12.8 23.2L16 21.6L12 13.6L18.4 13.6L4 0Z"
				fill="currentColor"
			/>
		</svg>
	);
}

/** Zoom controls: fit all cards / reset view. */
export function FitAllIcon() {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M17.2333 0.968792L17.2158 0.962958L14.9533 0.212958C14.1718 -0.0464953 13.3311 -0.0693975 12.5367 0.147125L7.89 1.49629C7.32105 1.64707 6.71726 1.59401 6.18333 1.34629L5.76667 1.15296C5.13383 0.88977 4.44584 0.786756 3.76366 0.853047C3.08149 0.919338 2.4262 1.15289 1.85588 1.53299C1.28555 1.9131 0.817796 2.42803 0.494069 3.03215C0.170342 3.63626 0.000639405 4.31091 0 4.99629L0 15.0588C0.00175133 15.9599 0.294827 16.8363 0.835492 17.5572C1.37616 18.2781 2.13543 18.8048 3 19.0588L5.39083 19.8088C5.79418 19.9342 6.21428 19.9974 6.63667 19.9963C7.01318 20.0011 7.38833 19.9502 7.75 19.8455L12.5833 18.5121C13.025 18.3923 13.4911 18.3961 13.9308 18.523L15.8833 19.0863C16.3735 19.2048 16.8842 19.2105 17.3769 19.1031C17.8696 18.9956 18.3316 18.7778 18.7279 18.4659C19.1242 18.1541 19.4446 17.7564 19.665 17.3028C19.8853 16.8491 19.9999 16.3514 20 15.8471V4.89296C19.9987 4.03366 19.7324 3.19567 19.2372 2.49337C18.7421 1.79107 18.0423 1.25866 17.2333 0.968792ZM3.48 17.4621C2.95859 17.3113 2.50008 16.9957 2.17316 16.5624C1.84625 16.1291 1.66854 15.6016 1.66667 15.0588V4.99629C1.66262 4.58352 1.76246 4.17637 1.95702 3.81231C2.15158 3.44824 2.43459 3.13897 2.78 2.91296C3.191 2.64033 3.67346 2.49536 4.16667 2.49629C4.48472 2.49638 4.79963 2.55925 5.09333 2.68129C5.09333 2.68129 5.71417 2.94713 5.8325 2.98962V18.198L3.48 17.4621ZM7.5 18.1855V3.22879C7.78305 3.21377 8.06389 3.1705 8.33833 3.09963L12.5 1.89046V16.8296L7.5 18.1855ZM18.3333 15.8471C18.3335 16.0967 18.2776 16.3432 18.1698 16.5683C18.0619 16.7935 17.9049 16.9915 17.7103 17.1478C17.5157 17.3041 17.2884 17.4147 17.0453 17.4714C16.8023 17.5281 16.5495 17.5295 16.3058 17.4755L14.1667 16.873V1.72546L16.6817 2.54129C17.165 2.71642 17.5828 3.03602 17.8783 3.45673C18.1737 3.87743 18.3326 4.37886 18.3333 4.89296V15.8471Z"
				fill="currentColor"
			/>
		</svg>
	);
}
